const RandomNumber = (data) => {
  return Math.floor(Math.random() * data);
};

export default RandomNumber;
